var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormWrapper",
    [
      _c(
        "FormControl",
        [
          _c("FormLabel", [_vm._v(_vm._s(_vm.$t("watchmen.form.name")))]),
          _vm._v(" "),
          _c("UiInput", {
            attrs: {
              disabled: !!_vm.proceduresCount,
              placeholder: _vm.$t("watchmen.form.name_placeholder"),
            },
            model: {
              value: _vm.watchman.name,
              callback: function ($$v) {
                _vm.$set(_vm.watchman, "name", $$v)
              },
              expression: "watchman.name",
            },
          }),
          _vm._v(" "),
          !!_vm.proceduresCount
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-info d-flex align-items-center mb-0 py-2",
                  attrs: { role: "alert" },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-lock fa-lg mr-3",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("watchmen.form.errors.procedures_no_edit"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "FormControl",
        [
          _c("FormLabel", [
            _vm._v(_vm._s(_vm.$t("watchmen.form.description"))),
          ]),
          _vm._v(" "),
          _c("Textarea", {
            model: {
              value: _vm.watchman.description,
              callback: function ($$v) {
                _vm.$set(_vm.watchman, "description", $$v)
              },
              expression: "watchman.description",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }